import useStyles from 'isomorphic-style-loader/useStyles'
import React from 'react'
import { useCallback } from "react"
import { Swiper, SwiperSlide } from 'swiper/react'
import { IMAGE_GEEKO_LTD } from "../../../../../../constants"
import { getColor } from "../../../../../../utils/product"
import { useWebp } from "../../../../../hooks/common"
import classes from '../shop-the-look-mask/style.module.scss'

const ImageSwiper = props => {
	useStyles(classes)
	const { product } = props

	const isWebp = useWebp()

	let images = product?.pcExtraImageUrls || []
	images = [product?.pcMainImage, ...images]


    const imagePrefix = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp':''}`


	return product ? <Swiper
		onSlideChange={() => {
		}}
		onSwiper={(swiper) => {
		}}
		spaceBetween={10}
		slidesPerView='auto'
	>
		{
			images?.map((image, index) => <SwiperSlide className={classes.EditorDisplayImage} key={index}>
				<img src={`${imagePrefix}/medium/${image}`} />
			</SwiperSlide>)
		}

	</Swiper> : <Swiper
		onSlideChange={() => {
		}}
		onSwiper={(swiper) => {
		}}
		spaceBetween={10}
		slidesPerView='auto'
	>
		{
			[{}, {}, {}].map((image, index) => <SwiperSlide className={classes.EditorDisplayImage} key={index}>

			</SwiperSlide>)
		}

	</Swiper>
}

const ColorSwiper = props => {
	const { products, selectedProduct, selectVariant, style } = props

	const isWebp = useWebp()

	const imagePrefix = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp':''}`

	const isSameProduct = useCallback((p1, p2, p3) => {
        if(p3){
            return p1?.variants?.[0]?.color === p3?.color
        } else {
            return p1?.id === p2?.id && p1?.variants?.[0]?.color === p2?.variants?.[0]?.color
        }
	}, [])

    const isSameVariant = useCallback((p1, p2) => {
        let isSameV = p1?.variants?.[0]?.color === p2?.color
		return isSameV
	}, [])

	return products ? <Swiper
		onSlideChange={() => {
		}}
		onSwiper={(swiper) => {
		}}
		spaceBetween={10}
		slidesPerView='auto'
	>
		{
			products?.map((product, index) => 
                style === 1 ? 
                <SwiperSlide style={{
                    backgroundColor: `${getColor(product?.variants?.[0]?.color)}`,
                    backgroundImage: product?.variants?.[0]?.colorImage ? `url(${product?.variants?.[0]?.colorImage})`: undefined
                }} onClick={() => { props?.onSelect(product) }} className={`${classes.EditorColorPlus} ${isSameProduct(product, selectedProduct, selectVariant) ? classes.Selected : ''}`} key={index}>
                    
                </SwiperSlide> :
                 <SwiperSlide onClick={() => { props?.onSelect(product) }} className={`${classes.EditorColor} ${(isSameProduct(product, selectedProduct, selectVariant)) ? classes.Selected : ''}`} key={index}>
                    <img src={`${imagePrefix}/small/${product?.variants?.[0]?.image || product.pcMainImage}`} />
                </SwiperSlide>)
		}

	</Swiper> : <Swiper

		spaceBetween={10}
		slidesPerView='auto'
	>
		{
			[{}, {}, {}].map((product, index) => <SwiperSlide className={`${classes.EditorColor}`} key={index}>
			</SwiperSlide>)
		}

	</Swiper>
}

const SizeSwiper = props => {
	const { selectedProduct, variants, selectedVariant } = props

	return variants ? <Swiper
		spaceBetween={10}
		slidesPerView='auto'
	>
		{
			variants?.map((variant, index) => 
            <SwiperSlide 
                onClick={() => { props?.onSelect(variant, selectedProduct) }} 
                className={`${classes.EditorSize} ${(variant.id === selectedVariant?.id || variant.size === selectedVariant?.size)? classes.Selected : ''}`} 
                key={variant.id}>
				{variant.size2 || variant.size}
			</SwiperSlide>)
		}

	</Swiper> : <Swiper
		spaceBetween={10}
		slidesPerView='auto'
	>
		{
			[{}, {}, {}].map((variant, index) => <SwiperSlide className={`${classes.EditorSize}`} key={index}>
			</SwiperSlide>)
		}
	</Swiper>


}

export {
    SizeSwiper,
    ColorSwiper,
    ImageSwiper
}